import {useMatches} from 'react-router';

import {inferAppLanguage} from '@/shared/lib/appLanguageSupports';

/**
 * The `($lang)` segment of the matched route, as a canonical tag for
 * `<html lang>`. `undefined` on routes that carry no language segment
 * (`/app/*`, `/checkout/*`), which pick their language from app settings.
 *
 * `useParams` cannot be used here: inside the root `Layout` the route context
 * holds only the root match, so the child route params are not visible.
 * `useMatches` reads them from the router state, leaf match included.
 */
export function useLangParam() {
  const matches = useMatches();
  const lang = matches[matches.length - 1]?.params.lang ?? '';

  return inferAppLanguage(lang);
}
